import React from 'react'
import { useLandingAccessControl } from '@/components/composed/landingBlocks/LandingAccessControlProvider'
import { ELandingAccessControlValue } from '@/components/composed/landingBlocks/LandingAccessControlProvider/types'
import { FinancingPreApprovedLoanBanner } from '@/pages/Financing/components/FinancingPreApprovedLoanBanner'
import { FinancingProductHelper } from '@/pages/Financing/components/FinancingProductHelper'

export const LandingFinancingProductPopups = () => {
  const { resolve } = useLandingAccessControl()

  return (
    <>
      {resolve('landings.components.productHelper') === ELandingAccessControlValue.VISIBLE && <FinancingProductHelper />}
      {resolve('landings.components.preApprovedLoanBanner') === ELandingAccessControlValue.VISIBLE && <FinancingPreApprovedLoanBanner />}
    </>
  )
}
